/* eslint-disable jsx-a11y/anchor-is-valid */
// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {User} from '../../core/_models'

type Props = {
  user: User
}

const UserInfoCell: FC<Props> = ({user}) => {
  // Get first letter for avatar fallback from first_name or last_name
  const getInitial = () => {
    if (user?.first_name) return user.first_name[0].toLowerCase()
    if (user?.last_name) return user.last_name[0].toLowerCase()
    return 'a'
  }

  const initial = getInitial()
  const displayName = user?.first_name || user?.last_name
    ? `${user?.first_name || ''} ${user?.last_name || ''}`.trim()
    : 'N/A'

  return (
    <div className='d-flex align-items-center'>
      <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
        <a href='#'>
          {user && user?.profile_picture ? (
            <div className='symbol-label'>
              <img src={user?.profile_picture} alt={'image'} className='w-100' />
            </div>
          ) : (
            displayName !== 'N/A' && (
              <div
                className={clsx(
                  'symbol-label fs-3',
                  `bg-light-${initial}`,
                  `text-${initial}`
                )}
              >
                {initial.toUpperCase()}
              </div>
            )
          )}
        </a>
      </div>
      <div className='d-flex flex-column'>
        <a
          href={`/apps/all-users/users/details-page/${user?._id}/profile`}
          className='text-gray-800 text-hover-primary mb-1'
        >
          {displayName}
        </a>

        <span
          style={{
            whiteSpace: 'nowrap',
          }}
        >
          {user?.email || 'N/A'}
        </span>
      </div>
    </div>
  )
}

const formatName = (name) => {
  if (name.length > 30) {
    return name.slice(0, -5) + '...'
  } else {
    return name
  }
}

export {UserInfoCell}
